import React from "react";
import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import Header2 from "../Coman/Header2";
import Footer2 from "../Coman/Footer2";

export default function TermsConditions() {
    return (
        <div className="terms-page" style={{ background: "#ffffff", minHeight: "100vh" }}>
            <div className="container" style={{ paddingTop: "40px", paddingBottom: "20px" }}>
                <Link to="/" style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "10px",
                    color: "var(--theme-color)",
                    textDecoration: "none",
                    fontSize: "15px",
                    fontWeight: "700",
                    padding: "10px 24px",
                    borderRadius: "50px",
                    border: "2px solid var(--theme-color)",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    transition: "all 0.3s ease"
                }}>
                    <Home size={18} />
                    Go Back Home
                </Link>
            </div>

            <section className="section-b-space" style={{ paddingBottom: "100px" }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="terms-container" style={{
                                background: "#ffffff",
                                backdropFilter: "blur(10px)",
                                borderRadius: "30px",
                                border: "1px solid rgba(0, 0, 0, 0.08)",
                                padding: "calc(25px + (60 - 25) * ((100vw - 320px) / (1920 - 320)))",
                                boxShadow: "0 20px 50px rgba(0,0,0,0.08)"
                            }}>
                                <div className="mb-5 pb-4" style={{ borderBottom: "1px solid rgba(0,0,0,0.1)" }}>
                                    <h2 className="mb-3" style={{ color: "#1a1a1a", fontWeight: "700" }}>Terms and Conditions
                                    </h2>
                                    <p style={{ color: "rgba(0,0,0,0.5)", fontSize: "16px" }}>

                                        Welcome to AGN (Adonai Group of Network). By accessing or using our platform, you agree to the following terms:



                                    </p>
                                </div>

                                <div className="terms-content">
                                    <div className="term-block mb-5">
                                        <h4 className="d-flex align-items-center mb-3" style={{ color: "var(--theme-color)", fontWeight: "700" }}>
                                            <span className="me-3" style={{ background: "rgba(var(--theme-color-rgb), 0.1)", width: "35px", height: "35px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px" }}>01</span>
                                            Acceptance of Terms


                                        </h4>
                                        <p style={{ color: "rgba(0,0,0,0.75)", lineHeight: "1.8", textAlign: "left" }}>
                                            By registering or using AGN services, you confirm that you have read, understood, and agreed to these Terms and Conditions.

                                        </p>
                                    </div>

                                    <div className="term-block mb-5">
                                        <h4 className="d-flex align-items-center mb-3" style={{ color: "var(--theme-color)", fontWeight: "700" }}>
                                            <span className="me-3" style={{ background: "rgba(var(--theme-color-rgb), 0.1)", width: "35px", height: "35px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px" }}>02</span>
                                            Nature of Services



                                        </h4>
                                        <div >
                                            <p style={{ color: "rgba(0,0,0,0.75)", lineHeight: "1.8", textAlign: "left" }}>
                                                AGN provides access to structured financial models including:

                                            </p>
                                            <ul style={{ listStyleType: "none", padding: "0", marginTop: "15px" }}>
                                                <li className="mb-2 d-flex align-items-center" style={{ color: "rgba(0,0,0,0.6)" }}>
                                                    <span style={{ color: "var(--theme-color)", marginRight: "10px" }}>✔</span> Asset-based participation models


                                                </li>
                                                <li className="mb-2 d-flex align-items-center" style={{ color: "rgba(0,0,0,0.6)" }}>
                                                    <span style={{ color: "var(--theme-color)", marginRight: "10px" }}>✔</span> Market-linked mechanisms



                                                </li>
                                                <li className="mb-2 d-flex align-items-center" style={{ color: "rgba(0,0,0,0.6)" }}>
                                                    <span style={{ color: "var(--theme-color)", marginRight: "10px" }}>✔</span> Network-based reward systems


                                                </li>
                                            </ul>
                                            <p className="mt-3" style={{ color: "var(--theme-color)", fontWeight: "600", fontStyle: "italic", textAlign: "left" }}>
                                                AGN does {" "}
                                                {/* <span className="text-muted"> */}
                                                not guarantee fixed or assured returns.
                                                {/* </span> */}



                                            </p>
                                        </div>
                                    </div>

                                    <div className="term-block mb-5">
                                        <h4 className="d-flex align-items-center mb-3" style={{ color: "var(--theme-color)", fontWeight: "700" }}>
                                            <span className="me-3" style={{ background: "rgba(var(--theme-color-rgb), 0.1)", width: "35px", height: "35px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px" }}>03</span>
                                            Eligibility
                                        </h4>
                                        <ul style={{ listStyleType: "none", padding: "0", paddingLeft: "50px" }}>
                                            <li className="mb-2 d-flex align-items-start" style={{ color: "rgba(0,0,0,0.75)", lineHeight: "1.8" }}>
                                                <span style={{ color: "var(--theme-color)", marginRight: "10px", marginTop: "4px" }}>•</span> Users must be at least 18 years old



                                            </li>
                                            <li className="mb-2 d-flex align-items-start" style={{ color: "rgba(0,0,0,0.75)", lineHeight: "1.8" }}>
                                                <span style={{ color: "var(--theme-color)", marginRight: "10px", marginTop: "4px" }}>•</span> Users must comply with local laws and regulations



                                            </li>
                                            <li className="mb-2 d-flex align-items-start" style={{ color: "rgba(0,0,0,0.75)", lineHeight: "1.8" }}>
                                                <span style={{ color: "var(--theme-color)", marginRight: "10px", marginTop: "4px" }}>•</span> AGN reserves the right to refuse service to any user


                                            </li>
                                        </ul>
                                    </div>

                                    <div className="term-block mb-5">
                                        <h4 className="d-flex align-items-center mb-3" style={{ color: "var(--theme-color)", fontWeight: "700" }}>
                                            <span className="me-3" style={{ background: "rgba(var(--theme-color-rgb), 0.1)", width: "35px", height: "35px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px" }}>04</span>
                                            User Responsibilities


                                        </h4>
                                        <div style={{ paddingLeft: "50px" }}>
                                            <p style={{ color: "rgba(0,0,0,0.75)", lineHeight: "1.8", textAlign: "left" }}>You agree:


                                            </p>
                                            <ul style={{ listStyleType: "none", padding: "0", marginTop: "10px" }}>
                                                <li className="mb-2 d-flex align-items-center" style={{ color: "rgba(0,0,0,0.6)" }}>
                                                    <span style={{ color: "var(--theme-color)", marginRight: "10px" }}>•</span> To provide accurate information


                                                </li>
                                                <li className="mb-2 d-flex align-items-center" style={{ color: "rgba(0,0,0,0.6)" }}>
                                                    <span style={{ color: "var(--theme-color)", marginRight: "10px" }}>•</span>Not to misuse the platform



                                                </li>
                                                <li className="mb-2 d-flex align-items-center" style={{ color: "rgba(0,0,0,0.6)" }}>
                                                    <span style={{ color: "var(--theme-color)", marginRight: "10px" }}>•</span>Not to engage in fraudulent or illegal activities



                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="term-block mb-5">
                                        <h4 className="d-flex align-items-center mb-3" style={{ color: "var(--theme-color)", fontWeight: "700" }}>
                                            <span className="me-3" style={{ background: "rgba(var(--theme-color-rgb), 0.1)", width: "35px", height: "35px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px" }}>05</span>
                                            Income & Earnings Disclaimer


                                        </h4>
                                        <ul style={{ listStyleType: "none", padding: "0", paddingLeft: "50px" }}>
                                            <li className="mb-2 d-flex align-items-start" style={{ color: "rgba(0,0,0,0.75)", lineHeight: "1.8" }}>
                                                <span style={{ color: "var(--theme-color)", marginRight: "10px", marginTop: "4px" }}>•</span>All earnings shown are illustrative or plan-based projections


                                            </li>
                                            <li className="mb-2 d-flex align-items-start" style={{ color: "rgba(0,0,0,0.75)", lineHeight: "1.8" }}>
                                                <span style={{ color: "var(--theme-color)", marginRight: "10px", marginTop: "4px" }}>•</span> Actual income may vary



                                            </li>
                                            <li className="mb-2 d-flex align-items-start" style={{ color: "rgba(0,0,0,0.75)", lineHeight: "1.8" }}>
                                                <span style={{ color: "var(--theme-color)", marginRight: "10px", marginTop: "4px" }}>•</span> Earnings depend on participation level, market conditions, and other factors


                                            </li>
                                            <li className="mb-2 d-flex align-items-start" style={{ color: "var(--theme-color)", fontWeight: "600" }}>
                                                <span style={{ color: "var(--theme-color)", marginRight: "10px", marginTop: "4px" }}>•</span>AGN does not guarantee profits


                                            </li>
                                        </ul>
                                    </div>

                                    <div className="term-block mb-5">
                                        <h4 className="d-flex align-items-center mb-3" style={{ color: "var(--theme-color)", fontWeight: "700" }}>
                                            <span className="me-3" style={{ background: "rgba(var(--theme-color-rgb), 0.1)", width: "35px", height: "35px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px" }}>06</span>
                                            Referral & Network Structure



                                        </h4>
                                        <ul style={{ listStyleType: "none", padding: "0", paddingLeft: "50px" }}>
                                            <li className="mb-2 d-flex align-items-start" style={{ color: "rgba(0,0,0,0.75)", lineHeight: "1.8" }}>
                                                <span style={{ color: "var(--theme-color)", marginRight: "10px", marginTop: "4px" }}>•</span> Referral income is optional



                                            </li>
                                            <li className="mb-2 d-flex align-items-start" style={{ color: "rgba(0,0,0,0.75)", lineHeight: "1.8" }}>
                                                <span style={{ color: "var(--theme-color)", marginRight: "10px", marginTop: "4px" }}>•</span>Users must not misrepresent AGN as a “guaranteed income scheme”



                                            </li>
                                            <li className="mb-2 d-flex align-items-start" style={{ color: "rgba(0,0,0,0.75)", lineHeight: "1.8" }}>
                                                <span style={{ color: "var(--theme-color)", marginRight: "10px", marginTop: "4px" }}>•</span>Spamming or unethical promotion is strictly prohibited



                                            </li>
                                        </ul>
                                    </div>

                                    <div className="term-block mb-5">
                                        <h4 className="d-flex align-items-center mb-3" style={{ color: "var(--theme-color)", fontWeight: "700" }}>
                                            <span className="me-3" style={{ background: "rgba(var(--theme-color-rgb), 0.1)", width: "35px", height: "35px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px" }}>07</span>
                                            Payments & Withdrawals



                                        </h4>
                                        <ul style={{ listStyleType: "none", padding: "0", paddingLeft: "50px" }}>
                                            <li className="mb-2 d-flex align-items-start" style={{ color: "rgba(0,0,0,0.75)", lineHeight: "1.8" }}>
                                                <span style={{ color: "var(--theme-color)", marginRight: "10px", marginTop: "4px" }}>•</span> All transactions are subject to internal verification



                                            </li>
                                            <li className="mb-2 d-flex align-items-start" style={{ color: "rgba(0,0,0,0.75)", lineHeight: "1.8" }}>
                                                <span style={{ color: "var(--theme-color)", marginRight: "10px", marginTop: "4px" }}>•</span>

                                                AGN reserves the right to delay or reject withdrawals in case of suspicious activity


                                            </li>
                                        </ul>
                                    </div>

                                    <div className="term-block mb-5">
                                        <h4 className="d-flex align-items-center mb-3" style={{ color: "var(--theme-color)", fontWeight: "700" }}>
                                            <span className="me-3" style={{ background: "rgba(var(--theme-color-rgb), 0.1)", width: "35px", height: "35px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px" }}>08</span>
                                            Risk Disclosure



                                        </h4>
                                        <div style={{ paddingLeft: "50px" }}>
                                            <p style={{ color: "rgba(0,0,0,0.75)", lineHeight: "1.8", textAlign: "left" }}>Participation involves financial risk. Users should:

                                            </p>


                                            <ul style={{ listStyleType: "none", padding: "0", marginTop: "10px" }}>
                                                <li className="mb-2 d-flex align-items-center" style={{ color: "rgba(0,0,0,0.6)" }}>
                                                    <span style={{ color: "var(--theme-color)", marginRight: "10px" }}>•</span>Evaluate risks before investing


                                                </li>
                                                <li className="mb-2 d-flex align-items-center" style={{ color: "rgba(0,0,0,0.6)" }}>
                                                    <span style={{ color: "var(--theme-color)", marginRight: "10px" }}>•</span>Seek independent financial advice if needed


                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="term-block mb-5">
                                        <h4 className="d-flex align-items-center mb-3" style={{ color: "var(--theme-color)", fontWeight: "700" }}>
                                            <span className="me-3" style={{ background: "rgba(var(--theme-color-rgb), 0.1)", width: "35px", height: "35px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px" }}>09</span>
                                            Suspension & Termination


                                        </h4>
                                        <div style={{ paddingLeft: "50px" }}>
                                            <p style={{ color: "rgba(0,0,0,0.75)", lineHeight: "1.8", textAlign: "left" }}>AGN may suspend or terminate accounts for:

                                            </p>
                                            <ul style={{ listStyleType: "none", padding: "0", marginTop: "10px" }}>
                                                <li className="mb-2 d-flex align-items-center" style={{ color: "rgba(0,0,0,0.6)" }}>
                                                    <span style={{ color: "var(--theme-color)", marginRight: "10px" }}>•</span> Violation of terms



                                                </li>
                                                <li className="mb-2 d-flex align-items-center" style={{ color: "rgba(0,0,0,0.6)" }}>
                                                    <span style={{ color: "var(--theme-color)", marginRight: "10px" }}>•</span> Fraudulent behavior


                                                </li>
                                                <li className="mb-2 d-flex align-items-center" style={{ color: "rgba(0,0,0,0.6)" }}>
                                                    <span style={{ color: "var(--theme-color)", marginRight: "10px" }}>•</span>Regulatory concerns


                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="term-block mb-5">
                                        <h4 className="d-flex align-items-center mb-3" style={{ color: "var(--theme-color)", fontWeight: "700" }}>
                                            <span className="me-3" style={{ background: "rgba(var(--theme-color-rgb), 0.1)", width: "35px", height: "35px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px" }}>10</span>
                                            Modification of Terms


                                        </h4>
                                        <p style={{ color: "rgba(0,0,0,0.75)", lineHeight: "1.8", textAlign: "left" }}>
                                            AGN reserves the right to update these terms at any time without prior notice.


                                        </p>
                                    </div>

                                    <div className="term-block mb-5">
                                        <h4 className="d-flex align-items-center mb-3" style={{ color: "var(--theme-color)", fontWeight: "700" }}>
                                            <span className="me-3" style={{ background: "rgba(var(--theme-color-rgb), 0.1)", width: "35px", height: "35px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px" }}>11</span>
                                            Limitation of Liability


                                        </h4>
                                        <div style={{ paddingLeft: "50px" }}>
                                            <p style={{ color: "rgba(0,0,0,0.75)", lineHeight: "1.8", textAlign: "left" }}>AGN shall not be liable for:

                                            </p>
                                            <ul style={{ listStyleType: "none", padding: "0", marginTop: "10px" }}>
                                                <li className="mb-2 d-flex align-items-center" style={{ color: "rgba(0,0,0,0.6)" }}>
                                                    <span style={{ color: "var(--theme-color)", marginRight: "10px" }}>•</span> Financial losses


                                                </li>
                                                <li className="mb-2 d-flex align-items-center" style={{ color: "rgba(0,0,0,0.6)" }}>
                                                    <span style={{ color: "var(--theme-color)", marginRight: "10px" }}>•</span> Market fluctuations


                                                </li>
                                                <li className="mb-2 d-flex align-items-center" style={{ color: "rgba(0,0,0,0.6)" }}>
                                                    <span style={{ color: "var(--theme-color)", marginRight: "10px" }}>•</span>Indirect or incidental damages


                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="term-block">
                                        <h4 className="d-flex align-items-center mb-3" style={{ color: "var(--theme-color)", fontWeight: "700" }}>
                                            <span className="me-3" style={{ background: "rgba(var(--theme-color-rgb), 0.1)", width: "35px", height: "35px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px" }}>12</span>
                                            Governing Law



                                        </h4>
                                        <p style={{ color: "rgba(0,0,0,0.75)", lineHeight: "1.8", paddingLeft: "50px", textAlign: "left" }}>
                                            These terms shall be governed by applicable laws of the operating jurisdiction.


                                        </p>
                                    </div>
                                </div>

                                {/* <div className="text-center mt-5 pt-4" style={{ borderTop: "1px solid rgba(0,0,0,0.1)" }}>
                                    <p style={{ color: "rgba(0,0,0,0.45)", fontSize: "14px" }}>
                                        © {new Date().getFullYear()} AGN - Adonai Group of Network. All Rights Reserved.
                                    </p>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section >

            {/* <Footer2 /> */}
        </div >
    );
}
